import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedDataAccessWebappModule } from '@mode/shared/data-access-webapp';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ReportEditorFacade } from './report-editor.facade';
import { ReportEditorEffects } from './report-editor/report-editor.effects';
import * as fromReportEditor from './report-editor/report-editor.reducer';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { ChartsDomainModule } from '@mode/charts/domain';

@NgModule({
  imports: [
    CommonModule,
    ChartsDomainModule,
    SharedDataAccessWebappModule,
    StoreModule.forFeature(fromReportEditor.reportEditorFeatureKey, fromReportEditor.reducer),
    EffectsModule.forFeature([ReportEditorEffects]),
  ],
  providers: [ReportEditorFacade],
})
export class ReportEditorDomainModule {}
